<div class="login-container">
  <video autoplay muted loop playsinline webkit-playsinline preload="auto" class="background-video" (error)="onVideoError($event)">
    <source src="https://admin.hc-cargo.com.my/assets/images/backgrounds/bg-map.mp4" type="video/mp4" />
  </video>
  <div class="login-form">
    <mat-card style="text-align: center;">
      <div>
        <mat-form-field appearance="fill" class="w-100">
          <mat-select [(ngModel)]="selectedApp" [ngModelOptions]="{standalone: true}" (selectionChange)="onAppSelectionChange($event)">
              <mat-option *ngFor="let item of appLoginSelection" [value]="item" appearance="fill">
                {{ item.url }}
                <!-- <div class="row mb-2">
                  <div class="col-md-12">{{ item.url }}</div> 
                  <div class="col-md-12 mt-0" style="font-size: small;">{{ item.id }}</div> 
                </div> -->
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>	  
           <img class="logosize" [src]="logoUrl">
      </div>
      <div>
        <mat-form-field appearance="fill" class="w-100">
          <mat-select [(ngModel)]="selectedUser" [ngModelOptions]="{standalone: true}" (selectionChange)="onUserSelectionChange($event)">
            <mat-option *ngFor="let item of selectedLogins" [value]="item" appearance="fill">
              {{ item.username }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div class="loginpad w-100">
        <div class="heading-login">Login</div>
        <div class="heading-sublogin">Enter your access details</div>
      </div> -->
      <mat-card-content>
        <form [formGroup]="frmLogin" (ngSubmit)="submitForm()" >
          <div class="row">
            <div>
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Username</mat-label>
                <input type="text" matInput placeholder="Ex. username" formControlName="username" required/>
                <mat-icon [ngStyle]="{ 'color': backColor}" matSuffix>account_circle</mat-icon>
                <mat-error *ngIf="frmLogin.hasError('required', 'username')">
                  Username is required.
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Password</mat-label>
                <input
                  matInput
                  placeholder="Ex. 12345"
                  formControlName="password"
                  required
                  [type]="hide ? 'password' : 'text'"
                />
                <mat-icon matSuffix [ngStyle]="{ 'color': backColor}" (click)="showPassword()">remove_red_eye</mat-icon>
                <mat-error *ngIf="frmLogin.hasError('required', 'password')">
                  Password is required.
                </mat-error>
              </mat-form-field>
    
            </div>
            <div>
              <button mat-flat-button [ngStyle]="{ 'background-color': backColor, 'color': foreColor}" [disabled]="!frmLogin.valid">Login Now</button>
            </div>
            <div>
              <div class="footerlinks martop">
                <div>
                  <mat-checkbox formControlName="shouldRemember">Remember Me!</mat-checkbox>
                </div>
                <div>
                  <div class="forgotpassword" routerLink="/reset-password">
                    Forget Password?
                  </div>
                </div>
              </div>
            </div>
    </div>
        </form>
      </mat-card-content>
      <mat-card-footer>
        <mat-card-actions align="end" style="font-size: smaller;">
          <span class="w-100" >ver: {{appVersion}}</span> 
        </mat-card-actions>
      </mat-card-footer>
    </mat-card> 
  </div>
</div>
